import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie';
import { AnalyticsEvent, AnalyticsService } from '../../../core/services/analytics-service';
import { AuthStoreService } from '../../../shared/services/auth/auth-store.service';
import { ILinkOfferPayload, IOffer } from '../../models/model';
import { OfferType } from '../../models/offer-type.enum';
import { CustomerStoreService } from '../../../core/services/customer-store.service';

@Component({
standalone: false,
  selector: 'app-offer-details',
  styleUrls: ['./offer-details-dialog.component.scss'],
  templateUrl: './offer-details-dialog.component.html',
})
export class OfferDetailsDialogComponent implements OnInit {
  public loading: boolean;
  public loadingError: boolean;

  public nameControl = new FormControl('', Validators.required);
  public surnameControl = new FormControl('', Validators.required);
  public phoneControl = new FormControl('', Validators.required);
  public consentControl = new FormControl('', Validators.requiredTrue);
  public offerType = OfferType;
  public linkUrl: string;

  public form = new FormGroup({
    consent: this.consentControl,
    name: this.nameControl,
    phone: this.phoneControl,
    surname: this.surnameControl,
  });

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public offer: IOffer,
    private dialogRef: MatDialogRef<OfferDetailsDialogComponent>,
    private analytics: AnalyticsService,
    private auth: AuthStoreService,
    private sanitizer: DomSanitizer,
    private cookies: CookieService,
    private customerStoreService: CustomerStoreService,
  ) {
    const payload = offer.payload as ILinkOfferPayload;
    this.linkUrl = offer.customerIdParamName
      ? this.appendCustomerIdToLinkUrl(offer, this.customerStoreService.state.customerId)
      : payload?.linkUrl;
  }

  public ngOnInit(): void {
    this.offerDetailsDisplayed();
  }

  public submitOrangeForm(): void {
    this.form.updateValueAndValidity();
    Object.values(this.form.controls).forEach((control) => control.markAsTouched());

    if (this.form.invalid) {
      return;
    }

    const payload = {
      form: this.form.getRawValue(),
      offerId: this.offer.offerId,
      source: this.offer.source,
    };

    this.cookies.put(`offer-form-${this.offer.offerId}`, 'submitted');
    this.analytics.trackEvent(new AnalyticsEvent('Orange Form Submitted', payload));
    this.dialogRef.close('submit');
  }

  public offerDetailsDisplayed(): void {
    this.analytics.trackEvent(
      new AnalyticsEvent('Offer Details Displayed', {
        offerId: this.offer.offerId,
        title: this.offer.title,
        type: this.offer.type,
      }),
    );
  }

  public linkClicked(): void {
    this.analytics.trackEvent(
      new AnalyticsEvent('Offer Link Clicked', {
        offerId: this.offer.offerId,
        title: this.offer.title,
        ...this.offer.payload,
      }),
    );
  }

  private appendCustomerIdToLinkUrl(offer: IOffer, customerId: string) {
    const payload = offer.payload as ILinkOfferPayload;
    const url = payload?.linkUrl;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${offer.customerIdParamName}=${customerId}`;
  }
}
